var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg03D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.5625 0.3125 3.5625 0.3125 5.5 1.6875 C6.5625 3.3125 6.5625 3.3125 6.5625 5.3125 C8.2125 5.3125 9.8625 5.3125 11.5625 5.3125 C11.81 6.09625 12.0575 6.88 12.3125 7.6875 C13.71639099 10.63567108 14.56925737 11.2149777 17.5625 12.3125 C17.60504356 14.31204746 17.60330783 16.31291636 17.5625 18.3125 C14.86178847 21.01321153 6.76579036 19.49815282 3.125 19.5 C1.85849609 19.51224609 0.59199219 19.52449219 -0.71289062 19.53710938 C-1.92009766 19.53904297 -3.12730469 19.54097656 -4.37109375 19.54296875 C-6.0425647 19.54913208 -6.0425647 19.54913208 -7.74780273 19.55541992 C-10.4375 19.3125 -10.4375 19.3125 -12.4375 17.3125 C-12.8125 13.875 -12.8125 13.875 -12.4375 10.3125 C-10.5625 8.375 -10.5625 8.375 -8.4375 7.3125 C-7.7775 7.3125 -7.1175 7.3125 -6.4375 7.3125 C-6.251875 6.136875 -6.251875 6.136875 -6.0625 4.9375 C-5.09367987 0.86845544 -4.15978436 0.37816221 0 0 Z ",
    fill: "#F2F2F2",
    transform: "translate(22.4375,15.6875)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03D);
export default __webpack_public_path__ + "static/media/03d.800eff0b3fd9057ae8f3764e6bb383ff.svg";
export { ForwardRef as ReactComponent };